<dt-table-layout *dtDataLoad="displayedTags != null; error: hasError">
  <div header class="cp-filters-form">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label i18n>Nach Name filtern</mat-label>
      <input matInput type="text" [(ngModel)]="nameFilter" (input)="updateDisplayedTags()" />
    </mat-form-field>

    <button mat-raised-button color="primary" (click)="addTag()"
      ><mat-icon>add</mat-icon><ng-container i18n>Tag hinzufügen</ng-container></button
    >
  </div>

  <table
    mat-table
    [dataSource]="displayedTags"
    matSort
    [matSortDisableClear]="true"
    [matSortActive]="activeSort.active"
    [matSortDirection]="activeSort.direction"
    (matSortChange)="onSortChange($event)"
  >
    <ng-container matColumnDef="nameDe">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Deutscher Name</th>
      <td mat-cell *matCellDef="let row">{{ row.name.de }}</td>
    </ng-container>
    <ng-container matColumnDef="nameEn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Englischer Name</th>
      <td mat-cell *matCellDef="let row">{{ row.name.en }}</td>
    </ng-container>
    <ng-container matColumnDef="weight">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Gewicht</th>
      <td mat-cell *matCellDef="let row">{{ row.weight ?? '—' }}</td>
    </ng-container>
    <ng-container matColumnDef="updatedAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Aktualisiert am</th>
      <td mat-cell *matCellDef="let row">{{ row.updatedAt | date: 'medium' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="showDetails(row)"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length" i18n>Keine Tags entsprechen dem Filter.</td>
    </tr>
  </table>

  <dt-table-footer [totalCount]="tags.length" [visibleCount]="displayedTags.length"></dt-table-footer>
</dt-table-layout>
